import React from "react"
import {useSearchParams} from "react-router"

import {DEFAULT_REACH_PERIOD, parseReachPeriod, TReachPeriod} from "./period"

const PERIOD_PARAM = "period"

export function useReachEnginePeriod(): [TReachPeriod, (next: TReachPeriod) => void] {
  const [params, setParams] = useSearchParams()

  const value = React.useMemo(() => parseReachPeriod(params.get(PERIOD_PARAM)), [params])

  const setValue = React.useCallback(
    (next: TReachPeriod) => {
      setParams(
        prev => {
          const search = new URLSearchParams(prev)
          if (next === DEFAULT_REACH_PERIOD) {
            search.delete(PERIOD_PARAM)
          } else {
            search.set(PERIOD_PARAM, next)
          }
          return search
        },
        {replace: true}
      )
    },
    [setParams]
  )

  return [value, setValue]
}
